import { Body } from './components/Body';
import { Cell } from './components/Cell';
import { Row } from './components/Row';
export const Table = {
    Body,
    Row,
    Cell,
};
